import React, { useCallback, useEffect, useState } from 'react';
import { Card } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Loader2 } from 'lucide-react';
import api from '../../utils/axios';
import { EventoItem } from './EventoItem';
import { TIPOS } from './actividadUtils';

const TODOS = '__todos__';

export const EventosFeed = ({ usuarios, dias }) => {
  const [tipo, setTipo] = useState(TODOS);
  const [userId, setUserId] = useState(TODOS);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { dias, limit: 300 };
      if (tipo !== TODOS) params.tipo = tipo;
      if (userId !== TODOS) params.user_id = userId;
      const r = await api.get('/actividad-usuarios/eventos', { params });
      setItems(r.data.items || []);
    } catch { setItems([]); } finally { setLoading(false); }
  }, [tipo, userId, dias]);

  useEffect(() => { load(); }, [load]);

  return (
    <Card className="bg-white border-slate-200" data-testid="act-feed">
      <div className="p-4 flex flex-wrap gap-3 border-b border-slate-100">
        <Select value={tipo} onValueChange={setTipo}>
          <SelectTrigger className="w-48" data-testid="act-feed-tipo"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={TODOS}>Todo tipo</SelectItem>
            {Object.entries(TIPOS).map(([k, l]) => <SelectItem key={k} value={k} data-testid={`act-feed-tipo-${k}`}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={userId} onValueChange={setUserId}>
          <SelectTrigger className="w-64" data-testid="act-feed-usuario"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={TODOS}>Todos los usuarios</SelectItem>
            {usuarios.map((u) => <SelectItem key={u.id} value={u.id}>{u.nombre || u.email}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="px-4 max-h-[34rem] overflow-y-auto">
        {loading ? (
          <div className="py-12 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-teal-700" /></div>
        ) : items.length ? (
          <ul className="divide-y divide-slate-100">
            {items.map((e, i) => <EventoItem key={e.id || `${e.fecha}-${i}`} e={e} testid={`act-evento-${i}`} />)}
          </ul>
        ) : (
          <p className="py-12 text-center text-sm text-slate-400" data-testid="act-feed-vacio">No hay actividad para este filtro.</p>
        )}
      </div>
    </Card>
  );
};

export default EventosFeed;
